export class WaveLevelData
{
  _data:Int8Array;
  _normalizedToDataIndex:number;

  constructor( numSamples:number, normalizedToDataIndex:number )
  {
    this._data = new Int8Array( numSamples );
    this._normalizedToDataIndex = normalizedToDataIndex;
  }

  sampleClosest( normalized:number )
  {
    let dataIndex = Math.round( normalized * this._normalizedToDataIndex );

    if ( dataIndex < 0 || dataIndex >= this._data.length )
    {
      return 0;
    }

    return this._data[ dataIndex ];
  }

  sample( normalized:number )
  { 
    let dataIndex = normalized * this._normalizedToDataIndex;

    if ( dataIndex < 0 || dataIndex >= this._data.length )
    {
      return 0;
    }

    let lowerIndex = Math.floor( dataIndex );
    let upperIndex = lowerIndex + 1 ;

    let lerpAmount = dataIndex - lowerIndex;

    let lowerValue = this._data[ lowerIndex ];
    let upperValue = this._data[ upperIndex ];

    return lowerValue + lerpAmount * ( upperValue - lowerValue );
  }
}